/** Dev route `/?replay=latest`: plays the last recorded mission back through the real game and checks the final hash. */

import type { WebGLRenderer } from 'three';
import { startMission } from './missionApp';
import { num } from './params';
import { loadLatestReplay, missionFor } from './replay';
import { expand } from './replayCodec';

export function startReplay(canvas: HTMLCanvasElement, renderer: WebGLRenderer): void {
  const file = loadLatestReplay();
  if (!file) {
    const note = document.createElement('div');
    note.textContent = 'NO REPLAY HAS BEEN RECORDED YET. FLY A MISSION FIRST.';
    note.style.cssText = 'position:fixed;inset:0;display:grid;place-items:center;font:16px monospace;color:#d8a028';
    document.body.append(note);
    return;
  }
  const options: Parameters<typeof startMission>[2] = {
    def: missionFor(file.source),
    mods: file.mods,
    skipInsertion: file.skipInsertion,
    pitch: num('pitch', 45),
    ppm: num('ppm', 18),
    showHud: true,
    playback: { commands: expand(file.runs), finalHash: file.finalHash },
  };
  if (file.loadout) options.loadout = file.loadout;
  startMission(canvas, renderer, options);
}
